import { render, staticRenderFns } from "./lkuPr.vue?vue&type=template&id=9cd0530a"
import script from "./lkuPr.vue?vue&type=script&lang=js"
export * from "./lkuPr.vue?vue&type=script&lang=js"
import style0 from "./lkuPr.vue?vue&type=style&index=0&id=9cd0530a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports